import { SessionDraft, SessionDrillDraft } from '../state';
import { SessionDraftViewModel } from '../models/session-draft.view-model';
import { toSessionDrillViewModel } from './session-drill.view-model.mapper';

export const toSessionDraftViewModel = (draft: SessionDraft): SessionDraftViewModel => ({
  startedAt: new Date(draft.startedAt),
  planId: draft.planId,
  planTitle: draft.planTitle,
  activeIndex: draft.activeIndex,
  sessionDrills: draft.sessionDrills.map((sd: SessionDrillDraft) => toSessionDrillViewModel(sd))
});
